<script>
import { mapGetters } from 'vuex'

import LanguagePicker from '@components/common/language-picker.vue'
import OrderButton from '@components/common/_base-redirect-button.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    LanguagePicker,
    OrderButton
  },
  mixins: [
    Translatable
  ],
  data() {
    return {
      availableLanguages: [],
      showNavbar: true,
      lastScrollPosition: 0
    }
  },
  computed: {
    ...mapGetters('menu', [
      'menuData',
    ]),
  },
  methods: {
    toggleBurger() {
      this.$refs.burger.classList.toggle('open')
      this.$refs.header.classList.toggle('expanded')
      this.$refs.dropdown.classList.toggle('hidden')
    },
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<template>
  <header ref="header" :class="{ 'header--hidden': !showNavbar }">
    <div class="container wrapper">
      <nav>
        <ul class="left-nav">
          <li ref="burger" class="burger" @click="toggleBurger">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </li>
          <router-link style="border-bottom: none" class="logo" exact-active-class="logo" to="/">{{ getTranslatedContent('HEADER_coolpass') }}</router-link>
        </ul>
        <ul ref="dropdown" class="center-nav hidden">
          <template v-for="(el, i) in menuData">
            <div class="navbar-container" @click="toggleBurger" v-if="el.menu" :key="i">
              <router-link
                :to="el.link || '/'"
                class="navbar-link"
              >
              {{ getTranslatedContent('title', el.content) }}
              </router-link>
            </div>
          </template>
          <OrderButton :caption="getTranslatedContent('BUY_NOW')" :class="'mobile-order-button'" :target="'/eshop'"/>
        </ul>
        <ul class="right-nav">
          <OrderButton :caption="getTranslatedContent('BUY_NOW')" :class="'order-button'" :target="'/eshop'"/>
          <li class="language-picker-wrapper"><LanguagePicker :class="'language-picker'"/></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import '@design';

header {
  position: fixed;
  display: flex;
  justify-content: center;
  height: $header-height;
  width: 100%;
  background: rgba(37, 44, 62, 0.6);
  z-index: 120;
  transform: translate3d(0, 0, 0);
  transition: 0.2s all ease-out;
}

header.header--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

header.expanded {
  background: #444959;

  .language-picker {
    display: flex;
    margin-top: 11px;
  }

  .order-button {
    display: none;
  }
}

.mobile-order-button {
  display: none;
}

.wrapper {
  display: flex;
  width: 100%;
}

.navbar-container {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-style: normal;
  font-size: $navbar-link-font-size;
  line-height: 130%;
  text-decoration: none;
  color: #FFFFFF;
  cursor: pointer;
  margin-top: 11px;
  margin-bottom: 14px;
  margin-right: 30px;
  white-space: nowrap;
  a{
    text-decoration: none;
    color: #FFFFFF;

  }
}

.router-link-active {
  border-bottom: 1px solid $orange;
}

.logo {
  font-family: Marselis Pro, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 23px;
  line-height: 130%;
  text-decoration: none;
  color: #FFFFFF;
  cursor: pointer;
  margin-right: auto;
  margin-top: 6px;
  margin-bottom: 7px;
}

nav {
  display: flex;
  margin: 0 auto;
}

nav ul {
  display: flex;
}

nav ul li {
  margin-right: 30px;
}

.left-nav {
  justify-content: flex-start;
}

.center-nav {
  flex: 1 1 auto;
  margin-left: 50px;
  margin-right: 40px;
}

.center-nav li:first-child {
  margin-left: 0;
}

.right-nav li:last-child,
.center-nav li:nth-last-child(-n+2) {
  margin-right: 0;
}

.right-nav {
  justify-content: flex-end;
}

.right-nav a:first-child {
  margin-right: 11px;
  // &.router-link-exact-active {
  //   border-bottom: 1px solid $white;
  // }

  // &:hover {
  //   border-bottom: 1px solid $orange;
  // }
}

.nav-btn-margin-mixin {
  margin-top: 3px;
  margin-bottom: 5px;
}

.order-button {
  @extend .nav-btn-margin-mixin;
  min-width: 75px;
  padding: 0 20px;
  white-space: nowrap;
}

.language-picker {
  @extend .nav-btn-margin-mixin;
}

.burger {
  display: none;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $screen-width-xs) {
  header {
    height: 56px;
  }

  .order-button {
    margin-top: 11px;
    margin-right: 0 !important;
    min-width: 105px;
    height: 35px;
  }

  .language-picker {
    display: none;
  }

  nav {
    flex-wrap: wrap;
    display: flex;
    flex-direction: row;
    width: 100%;
    margin: 0;
  }

  nav ul {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .center-nav {
    position: absolute;
    display: flex;
    align-items: center;
    flex: 0 0 100%;
    flex-direction: column;
    order: 3;
    height: 375px;
    // width: 100%;
    background: #727580;
    padding-top: 42px;
    left: 0;
    right: 0;
    margin: 0;
    top: 100%;
    overflow: hidden;
    z-index: 1000;

    transition: height $duration-animation-base ease-in-out, padding $duration-animation-base ease-in-out;
  }

  .mobile-order-button {
    width: 258px !important;
    height: 35px !important;
    display: block;
    margin-left: 0;
    margin-bottom: 105px !important;

    box-sizing: border-box;
    border-radius: 5px;
    text-align: center;

    padding-left: 0 !important;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .center-nav li, .center-nav a {
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #FFFFFF;
    width: $mobile-container-width;
    margin: 0 0 30px;
    padding-left: 30px;
  }

  .center-nav li:first-child {
    margin-left: 30px;
    padding-left: 0;
  }

  .center-nav:last-child {
    margin-bottom: 52px;

  }

  .left-nav {
    flex-direction: row;
    align-items: center;
  }

  .right-nav {
    flex: 1 1 auto;
    justify-content: flex-end;
    flex-direction: unset;
    margin-right: 0 !important;
  }

  .burger {
    position: relative;
    cursor: pointer;
    display: block;
    width: 27px !important;
    height: 18px;
    margin-right: 15px;

    transform: rotate(0deg);
    transition: .5s ease-in-out;

    span {
      position: absolute;
      width: 100%;
      background-color: $orange;
      height: 2px;
      left: 0;
      border-radius: 2px;

      transform: rotate(0deg);
      transition: .25s ease-in-out;
    }

    span:nth-child(3),
    span:nth-child(2) {
      top: 8px;
    }

    span:nth-child(4) {
      top: 16px;
    }

    span {
      position: absolute;
      width: 100%;
      background-color: $orange;
      height: 2px;
      left: 0;
      border-radius: 2px;
    }
  }

  .open span:nth-child(4),
  .open span:nth-child(1) {
    display: none;
  }

  .open span:nth-child(2) {
    transform: rotate(45deg);
  }

  .open span:nth-child(3) {
    transform: rotate(-45deg);
  }

  .hidden {
    padding: 0;
    height: 0;
    transition: height $duration-animation-base ease-in, padding $duration-animation-base ease-in;
  }

  .router-link-active {
    border-bottom: none
  }

}
</style>
